import { apiFetch } from './client';

export type ManageableRole = 'admin' | 'developer';

export interface UserSummary {
  sub: string;
  email: string;
  enabled: boolean;
  status: string;
  role: 'admin' | 'developer' | 'public';
  createdAt?: string;
}

export interface ListUsersResponse {
  items: UserSummary[];
  /** False when user lifecycle (invite, enable/disable) lives in the central
   *  identity-service — the UI then only manages docs roles. */
  lifecycleManaged?: boolean;
}

export interface MeResponse {
  sub: string;
  email: string | null;
  /** Display name ("Firstname Lastname") from the IdP, when it provides one */
  name?: string | null;
  role: 'admin' | 'developer' | 'public';
}

export const getMe = () => apiFetch<MeResponse>('/api/v1/users/me');

export const listUsers = () => apiFetch<ListUsersResponse>('/api/v1/users');

export const createUser = (email: string, role: ManageableRole) =>
  apiFetch<{ sub: string; email: string; role: ManageableRole; status?: string }>('/api/v1/users', {
    method: 'POST',
    body: JSON.stringify({ email, role }),
  });

export const updateUser = (sub: string, changes: { role?: ManageableRole; enabled?: boolean }) =>
  apiFetch<{ sub: string; updated: boolean }>(`/api/v1/users/${encodeURIComponent(sub)}`, {
    method: 'PATCH',
    body: JSON.stringify(changes),
  });
